module.exports = __webpack_public_path__ + "static/media/informacion_icon.7598e4c8.svg";